export default __webpack_public_path__ + "static/media/checkbox-compare-switch.e97d7168.svg";